<mat-card class="card-linnks margin-linnks">
  <mat-card-title>
    {{title}}
    <mat-card-subtitle>
      {{subtitle}}
    </mat-card-subtitle>
  </mat-card-title>




  <div>
    <mat-card-content>
      <div class="box-content pt-2">

        <div class="header-box">
          <div class="header-box-content">
            <h3 class="title-card"> &nbsp;</h3>
            <div class="actions-card">
              <button type="button" class="btn btn-xs btn-link" (click)="dt2.exportCSV()" matTooltip="Exportar Excel"
                matTooltipPosition="above"><i class="far fa-file-excel excel"></i> </button>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>

        <p-table class="table-system" #dt2 [columns]="colslistaFormularioPerguntasCampos"
          [value]="listaFormularioPerguntasCampos" [paginator]="true" [rows]="rows"
          [totalRecords]="listaFormularioPerguntasCampos.length" [pageLinks]="pageLinks"
          [rowsPerPageOptions]="rowsPerPage" selectionMode="false" [style]="{'width':'100%'}">
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center tableHeaderCheckbox">
                <span class="check-all p-0">
                  <p-tableHeaderCheckbox (click)="selectTodos($event)"></p-tableHeaderCheckbox>
                </span>
              </th>

              <th class="text-left" style="width: 25%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'formularioNome'">
                  <span class="text-overflow-dynamic-ellipsis">FORMULÁRIO <p-sortIcon [field]="'formularioNome'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'formularioNome', 'contains')">
              </th>

              <th class="text-left" style="width: 53%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'perguntaDescricao'">
                  <span class="text-overflow-dynamic-ellipsis">PERGUNTA <p-sortIcon [field]="'perguntaDescricao'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'perguntaDescricao', 'contains')">
              </th>

              <th class="text-center" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'requeridoPt'">
                  <span class="text-overflow-dynamic-ellipsis">REQUERIDO <p-sortIcon [field]="'requeridoPt'">
                    </p-sortIcon></span>
                </span>
                <p-multiSelect class="type-p-mult" [options]="opcoesComboRequirido" defaultLabel="Selecione"
                  [filter]="false" (onChange)="dt2.filter($event.value, 'requeridoPt', 'in')"></p-multiSelect>
              </th>

              <th class="text-left" style="width: 10%;">
                <span class="text-overflow-dynamic-container" [pSortableColumn]="'posicaoCampo'">
                  <span class="text-overflow-dynamic-ellipsis">PERGUNTA Nº <p-sortIcon [field]="'posicaoCampo'">
                    </p-sortIcon></span>
                </span>
                <input class="form-control form-control-sm" type="text"
                  (input)="dt2.filter($event.target.value, 'posicaoCampo', 'contains')">
              </th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>

              <td class="text-center tableCheckbox">
                <p-tableCheckbox (click)="selectCheckbox(rowData.id , rowData)" [value]="rowData">
                </p-tableCheckbox>
              </td>

              <td class="text-left" style="width: 25%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis"
                    matTooltip="{{rowData?.formularioNome}}">{{rowData?.formularioNome }}</span>
                </span>
              </td>

              <td class="text-left" style="width: 53%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis"
                    matTooltip="{{rowData?.perguntaDescricao}}">{{rowData?.perguntaDescricao }}</span>
                </span>
              </td>

              <td class="text-center" style="width: 10%;">

                <p-checkbox class="mr-1" [(ngModel)]="rowData.requerido" [binary]="true"
                inputId="requerido" [disabled]="true"></p-checkbox>

              </td>

              <td class="text-right" style="width: 10%;">
                <span class="text-overflow-dynamic-container">
                  <span class="text-overflow-dynamic-ellipsis"
                    matTooltip="{{rowData?.posicaoCampo}}">{{rowData?.posicaoCampo }}</span>
                </span>
              </td>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-rowData>
            <tr>
              <td [attr.colspan]="5" class="spaced-alert">
                <div class="alert alert-xs alert-primary d-inline" role="alert">
                  <i class="fas fa-info-circle"></i> Nenhum Registro Encontrado!
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>



      </div>

      <div class="ui-g">
        <div class="ui-g-12">

        </div>
      </div>


      <p-dialog header="Campanha" [(visible)]="modalFormulario" [style]="{width: '800px'}" [modal]="true"
        styleClass="modal-scroll" [responsive]="true" appendTo="body" [closable]="true">



        <!-- modalConsultor -->
        <div *ngIf="modalFormulario">


          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>FORMULÁRIO</label>
              <p-dropdown class="type-p-dropdown" [filter]="true" placeholder="Selecione" [options]="opcoesFormulario"
                [(ngModel)]="formularioPerguntasCampo.formulario"></p-dropdown>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>PERGUNTA </label>
              <input [(ngModel)]="formularioPerguntasCampo.perguntaDescricao" class="form-control text-left" type="text"
                maxlength="250" />
            </div>
          </div>


          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>TIPO CAMPO</label>
              <p-dropdown class="type-p-dropdown" [filter]="true" placeholder="Selecione" [options]="opcoesTipoCampo"
                [(ngModel)]="formularioPerguntasCampo.formularioTipoCampo"></p-dropdown>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <label>POSIÇÃO </label>
              <input [(ngModel)]="formularioPerguntasCampo.posicaoCampo" class="form-control text-left" type="number"
                min="1" max="20" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12">
              <mat-slide-toggle [(ngModel)]="formularioPerguntasCampo.requerido"> REQUERIDO </mat-slide-toggle>
            </div>
          </div>

          <div class="ui-g" style="position:fixed; right: 25px; bottom: 30px;">
            <div class="ui-g-12">

            </div>
          </div>



        </div>


        <p-footer>
          <button type="button" class="btn btn-secondary" (click)="modalFormulario=false;"><i class="fas fa-undo"></i>
            Cancelar</button>
          <button *ngIf="!editFormulario" type="button" class="btn btn-primary"
            (click)="salvarFormularioPerguntasCampo();" [disabled]="btnSalvarDisabled"><i class="fas fa-check"></i>
            Salvar</button>
          <button *ngIf="editFormulario" type="button" class="btn btn-primary"
            (click)="editarFormularioPerguntasCampo();" [disabled]="btnSalvarDisabled"><i class="fas fa-check"></i>
            Salvar</button>
        </p-footer>
      </p-dialog>
      <!--Final Modal cadastro de Palestras-->

    </mat-card-content>
  </div>

</mat-card>